import styled, { css } from 'styled-components';

export const IconWrapper = styled.span(
  ({ theme, iconColor }) => `
    color: ${iconColor || theme.primaryBlue};
    svg {
      margin-right: .5rem;
    }
  `,
);

export const StatusLabel = styled.div(
  ({ theme, backgroundColor }) => css`
    position: absolute;
    top: 0;
    right: 0;
    width: 250px;
    font-size: 1rem;
    font-weight: 700;
    color: ${theme.white};
    background-color: ${backgroundColor};
    border-radius: 0 5px 0 5px;
    text-align: center;
    padding: 8px;

    @media (max-width: ${theme.screenSizes.tablet}) {
      width: 100%;
      border-radius: 5px 5px 0 0;
    }
  `,
);
